if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( ! document.body.classList.contains('template-cart') ) {
					document.getElementById('site-cart-sidebar').show();
					if ( KROWN.settings.cart_action == 'overlay') {
						document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
						});
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
						});
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
					};
				}
			});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

function updateDeliveryTimeDisplay(root) {
	if ( ! root || ! root.querySelector ) return;
	const countdownEl = root.querySelector('.st_OrderStatus-Green');
	const shippedEl = root.querySelector('.shipped');
	const deliveredEl = root.querySelector('.delivered');
	if ( ! countdownEl && ! shippedEl && ! deliveredEl ) return;

	function getNextNonWeekend(date) {
		while (date.getDay() === 0 || date.getDay() === 6) {
			date.setDate(date.getDate() + 1);
		}
		return date;
	}
	function getNextNonSunday(date) {
		while (date.getDay() === 0) {
			date.setDate(date.getDate() + 1);
		}
		return date;
	}
	function formatDateRange(startDate, endDate) {
		const options = { day: 'numeric', month: 'long' };
		const locale = document.documentElement.lang || 'de-DE';
		return `${startDate.toLocaleDateString(locale, options)} - ${endDate.toLocaleDateString(locale, options)}`;
	}
	function formatSingleDate(date) {
		const options = { day: 'numeric', month: 'long' };
		const locale = document.documentElement.lang || 'de-DE';
		return date.toLocaleDateString(locale, options);
	}

	const now = new Date();
	let targetTime = new Date();
	if (now.getHours() < 11) {
		targetTime.setHours(11, 0, 0, 0);
	} else {
		targetTime.setHours(23, 59, 59, 999);
	}
	let timeDiff = targetTime - now;
	let hours = Math.floor(timeDiff / (1000 * 60 * 60));
	let minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
	const locale = document.documentElement.lang || 'de-DE';
	const countdownText = locale.startsWith('de') ? `${hours} Std ${minutes} Min.` : `${hours} hours ${minutes} Min.`;
	if (countdownEl) countdownEl.textContent = countdownText;

	let shippedStartDate = new Date(now);
	let shippedEndDate;
	if (now.getHours() < 11) {
		shippedStartDate = getNextNonWeekend(shippedStartDate);
		shippedEndDate = null;
	} else {
		shippedStartDate = getNextNonWeekend(shippedStartDate);
		shippedEndDate = new Date(shippedStartDate);
		shippedEndDate.setDate(shippedEndDate.getDate() + 1);
		shippedEndDate = getNextNonWeekend(shippedEndDate);
	}

	let deliveredStartDate = new Date(now);
	if (now.getHours() < 11) {
		deliveredStartDate.setDate(deliveredStartDate.getDate() + 1);
	} else {
		deliveredStartDate.setDate(deliveredStartDate.getDate() + 2);
	}
	deliveredStartDate = getNextNonSunday(deliveredStartDate);
	let deliveredEndDate = new Date(deliveredStartDate);
	deliveredEndDate.setDate(deliveredEndDate.getDate() + 1);
	deliveredEndDate = getNextNonSunday(deliveredEndDate);

	const shippedText = shippedEndDate ? formatDateRange(shippedStartDate, shippedEndDate) : formatSingleDate(shippedStartDate);
	const deliveredText = formatDateRange(deliveredStartDate, deliveredEndDate);
	if (shippedEl) shippedEl.textContent = shippedText;
	if (deliveredEl) deliveredEl.textContent = deliveredText;
}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {

		constructor(){
			super();
			if ( this.querySelector('a') ) {
				this.init();
			}
		}

		initModalProduct(){

			this.quickViewModal.querySelectorAll('[data-js-close]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					document.body.classList.remove('quick-view-modal-open');
					this.quickViewModal.hide();
				});
			});

			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
				this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
					document.body.classList.remove('quick-view-modal-open');
					document.getElementById('site-cart-sidebar')?.scrollTo({top: 0, behavior: 'smooth'});
					this.quickViewModal.hide();
				});
			}

			if ( Shopify && Shopify.PaymentButton ) {
				setTimeout(()=>{
					Shopify.PaymentButton.init();
				}, 50);
			}

			const productVariants = this.quickViewModal.querySelector('product-variants');
			if ( ! productVariants._defaultToFirstVariant ) {
				if ( parseInt(productVariants.dataset.variants) == 1 ) {
					productVariants.updateBuyButtons();
					this.quickViewModal.querySelector('product-page').onVariantChangeHandler({target:productVariants});
				}
			}

			const modalContent = this.quickViewModal.querySelector('.modal-content');
			if ( modalContent ) updateDeliveryTimeDisplay(modalContent);

		}

		init(){

			this.quickViewModal = null;
			this.querySelector('a').addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					window.lastFocusedElm = this.querySelector('a');
				}
			})
			this.querySelector('a').addEventListener('click', e=>{

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;

					target.classList.add('working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

							// create modal w content

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"	
								class="modal modal--product" 
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": false
								}'
								tabindex="-1" role="dialog" aria-modal="true" 
							>
								<div class="container--medium">
									<div class="modal-content" data-js-product-page>
										<button class="modal-close" data-js-close style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);
							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							// Remove body class when modal closes (Escape, etc.) so quick-view-only CSS no longer applies
							const modalObserver = new MutationObserver(() => {
								if ( ! this.quickViewModal.classList.contains('active') ) {
									document.body.classList.remove('quick-view-modal-open');
								}
							});
							modalObserver.observe(this.quickViewModal, { attributes: true, attributeFilter: ['class'] });

							setTimeout(()=>{
								this.initModalProduct();
							}, 100);
							this.quickViewModal.querySelector('[data-js-product-page]').addEventListener('reload', ()=>{
								this.initModalProduct();
							});

							if ( ! window.productPageScripts ) {
								const scripts = this.quickViewModal.querySelectorAll('script');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
									window.productPageScripts = true;
								});
							}

							setTimeout(()=>{
								document.body.classList.add('quick-view-modal-open');
								this.quickViewModal.show();
								target.classList.remove('working');
							}, 250);
							
						});

				} else {
					document.body.classList.add('quick-view-modal-open');
					this.quickViewModal.show();
				}

			})
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}

/* ------------------------------------------------------------------
   Sunnafrucht Quick-Add fuer die Lovable-Produktkacheln (16.10.2026)
   Kategorie-Seiten (lovable-collection) und Alle Produkte (lovable-sortiment):
   Klick auf das Warenkorb-Symbol (.lvc-card__cart) legt 1 Stueck direkt in den
   Warenkorb und oeffnet die Warenkorb-Leiste. Laeuft ueber das product-form des
   Themes, wie der Theme-Schnellkauf. Variante und versteckte Eigenschaften
   (_INHALT, _Zolltarif-Nr.) kommen aus sections/lvc-quickadd-data.liquid.
   Ausverkauft, mehrere Varianten oder Fehler: weiter zur Produktseite wie bisher.
   ------------------------------------------------------------------ */
(function () {

	if ( window.sfLvcQuickAdd ) return;
	window.sfLvcQuickAdd = true;

	const dataCache = {};

	const productBaseUrl = card => {
		const url = new URL(card.href, window.location.href);
		url.search = '';
		url.hash = '';
		return url.toString();
	};

	const loadData = card => {
		const base = productBaseUrl(card);
		if ( ! dataCache[base] ) {
			dataCache[base] = fetch(`${base}?section_id=lvc-quickadd-data`)
				.then(response => {
					if ( ! response.ok ) throw new Error(response.status);
					return response.text();
				})
				.then(text => {
					const elm = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-lvc-qa-data]');
					if ( ! elm ) throw new Error('no data');
					return JSON.parse(elm.textContent);
				})
				.catch(error => {
					delete dataCache[base];
					throw error;
				});
		}
		return dataCache[base];
	};

	const getHolder = () => {
		let holder = document.getElementById('sf-lvc-quickadd');
		if ( holder ) return holder;
		const routes = ( window.KROWN && KROWN.settings && KROWN.settings.routes ) || {};
		const wrap = document.createElement('div');
		wrap.innerHTML = `<quick-add-to-cart id="sf-lvc-quickadd" class="quick-add-to-cart" style="display:none" hidden><product-form data-ajax-cart><form method="post" action="${routes.cart_add_url || '/cart/add'}" accept-charset="UTF-8" enctype="multipart/form-data"><input type="hidden" name="form_type" value="product"><input type="hidden" name="id" value=""><button type="submit" name="add" data-js-product-add-to-cart tabindex="-1" aria-hidden="true"></button></form></product-form></quick-add-to-cart>`;
		holder = wrap.querySelector('quick-add-to-cart');
		document.body.appendChild(holder);
		return holder;
	};

	const setProperty = (form, key, value) => {
		const name = `properties[${key}]`;
		let input = Array.from(form.querySelectorAll('input')).find(elm => elm.name === name);
		if ( value ) {
			if ( ! input ) {
				input = document.createElement('input');
				input.type = 'hidden';
				input.name = name;
				form.insertBefore(input, form.querySelector('button'));
			}
			input.value = value;
		} else if ( input ) {
			input.remove();
		}
	};

	const addToCart = (icon, data) => {
		const holder = getHolder();
		const productForm = holder.querySelector('product-form');
		const form = holder.querySelector('form');
		let timer = null;
		const done = () => {
			clearTimeout(timer);
			productForm.removeEventListener('add-to-cart', done);
			icon.classList.remove('sf-qa-busy');
		};
		form.querySelector('input[name="id"]').value = data.variant;
		setProperty(form, '_INHALT', data.inhalt);
		setProperty(form, '_Zolltarif-Nr.', data.hs);
		productForm.addEventListener('add-to-cart', done);
		timer = setTimeout(done, 8000);
		form.querySelector('button[type="submit"]').click();
	};

	const iconFrom = e => ( e.target && e.target.closest ) ? e.target.closest('a.lvc-card .lvc-card__cart') : null;

	const themeReady = () => window.customElements && customElements.get('product-form') && customElements.get('quick-add-to-cart') && document.getElementById('site-cart-sidebar');

	document.addEventListener('click', e => {
		const icon = iconFrom(e);
		if ( ! icon || ! themeReady() ) return;
		const card = icon.closest('a.lvc-card');
		e.preventDefault();
		if ( icon.classList.contains('sf-qa-busy') ) return;
		icon.classList.add('sf-qa-busy');
		const openProduct = () => {
			icon.classList.remove('sf-qa-busy');
			window.location.href = card.href;
		};
		loadData(card)
			.then(data => {
				if ( data && data.single && data.available && data.variant ) {
					addToCart(icon, data);
				} else {
					openProduct();
				}
			})
			.catch(openProduct);
	});

	document.addEventListener('pointerdown', e => {
		const icon = iconFrom(e);
		if ( icon ) loadData(icon.closest('a.lvc-card')).catch(() => {});
	}, { passive: true });

	const style = document.createElement('style');
	style.textContent = '.lvc-card__cart.sf-qa-busy{opacity:.55;cursor:progress}';
	document.head.appendChild(style);

})();
